export const LICENSE_TYPE_LABELS: Record<string, string> = {
  self_service: 'Self Service',
  service: 'Service',
  kiosk_terminal: 'Kiosk Terminal',
}

export const licenseTypeLabel = (type: string): string =>
  LICENSE_TYPE_LABELS[type] ?? type
